<template>
    <div class="fixed z-index-fixed top-0 overflow-hidden duration-500" :class="SideMenuStore.state.profileBar ? 'sidebar-open' : 'sidebar-close'">
        <div class="bg-black bg-opacity-70 w-screen h-screen fixed top-0 left-0"
             v-if="SideMenuStore.state.profileBar"
             @click="closeMenu()">
        </div>
        <div class="w-full h-screen bg-a-egg-f5ebdc relative">
            <div class="p-6 relative">
                <div class="absolute top-6 left-6">
                    <img class="w-6 cursor-pointer" @click="closeMenu()" src="@/assets/icon/ic-close-brown.svg" />
                </div>
                <div v-show="!showmore" class="mt-10 px-4">
                    <Mainmenu></Mainmenu>
                    <div class="block py-3">
                        <div class="flex justify-between items-center">
                            <div class="flex items-center cursor-pointer" @click="toggleMore()">
                                <div>
                                    <img class="h-25px" src="../../../assets/menu_icon/ic-More.svg">
                                </div>
                                <div class="ml-2 text-20 font-bold text-a-brown-502314">{{lbl.main.menubar.more}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="showmore" class="flex items-center mt-12 cursor-pointer" @click="toggleMore()">
                    <img class="h-3" src="../../../assets/arrow/back-btn.svg" >
                    <div class="pl-2 text-16 font-bold text-a-brown-502314 " >
                        Back to main menu
                    </div>
                </div>
                <div v-show="showmore" class="profile-content hide-scroll mt-4 overflow-y-auto">
                    <ProfileContent></ProfileContent>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Mainmenu from './components/Mainmenu/Mainmenu.vue';
import ProfileContent from '@/module/Profile/component/ProfileContent/ProfileContent.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    inject: ['SideMenuStore'],
    mixins: [LocaleMixin],
    components: {
        Mainmenu,
        ProfileContent,
    },
    data: function() {
        return {
            showmore: false,
        };
    },
    watch:{
        $route: function() {
            this.closeMenu();
        },

        'SideMenuStore.state.profileBar': function () {
            let active = this.SideMenuStore.state.profileBar;
            console.log('side menu change', this.SideMenuStore.state.profileBar);
            setTimeout(() => {
                if (active) {
                    document.body.classList.add('not-scroll');
                } else {
                    document.body.classList.remove('not-scroll');
                }
            }, 500);
        },
    },
    methods: {
        closeMenu: function() {
            this.SideMenuStore.methods.closeProfileBar();
        },

        clickGotoHome: function() {
            this.closeMenu();
            this.$router.push("/home");
        },

        toggleMore: function() {
            this.showmore = !this.showmore;
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .sidebar-open {
        width: 400px;
        left: 0px;
        // @include min-desktop {
        //     width: 456px;
        // }
    }
    .sidebar-close {
        width: 400px;
        left: -150vw;
        // @include min-desktop {
        //     width: 456px;
        //     right: -456px;
        // }
    }
    .profile-content {
        height: calc(100vh - 108px);
    }
</style>
